import { render, staticRenderFns } from "./hosting.vue?vue&type=template&id=d3965704&scoped=true&"
import script from "./hosting.vue?vue&type=script&lang=js&"
export * from "./hosting.vue?vue&type=script&lang=js&"
import style0 from "./hosting.vue?vue&type=style&index=0&id=d3965704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3965704",
  null
  
)

export default component.exports